export * from './authentication.service';
export * from './user.service';

export * from './api.service';
export * from './crm/company.service';
export * from './crm/contact.service';
export * from './crm/offer.service';
export * from './crm/classification.service';
export * from './crm/pricelist.service';
export * from './crm/delivery_method.service';
export * from './crm/payment_condition.service';
export * from './crm/representative.service';

export * from './shop/product.service';
export * from './shop/country.service';
export * from './shop/region.service';
export * from './shop/winery.service';
export * from './shop/color.service';
export * from './shop/favorite.service';
export * from './shop/grape.service';
export * from './shop/tastetype.service';
export * from './shop/appellation.service';
export * from './shop/volume.service';
export * from './shop/order.service';
export * from './shop/stock.service';
export * from './shop/shippingcost.service';
export * from './shop/voucher.service';

export * from './system-country.service';
export * from './province.service';

export * from './profile.service';
export * from './subscription.service';
export * from './profiler.service';
export * from './settings.service';
export * from './dashboard.service';



// WEBPACK FOOTER //
// /var/www/vhosts/s-wines.nl/httpdocs/crm/resources/assets/src/app/shared/services/index.ts